'use client';

import { useCanViewMaturityModelPage } from '@/domain/maturityModel/hooks';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Button } from '@andritzot/metris-web-ui/inputs/button';
import MenuOutlined from '@mui/icons-material/MenuOutlined';
import Link from 'next/link';
import { Menu } from 'primereact/menu';
import { type MenuItem } from 'primereact/menuitem';
import { useRef, useSyncExternalStore } from 'react';

import styles from './TopBar.module.scss';

const emptySubscribe = () => () => {};

const linkSx = {
  fontWeight: 600,
  letterSpacing: '0.08em',
  color: '#fff',
  display: 'block',
  fontSize: '14px',
  textTransform: 'uppercase',
  position: 'relative',
  padding: '0px 1px',
  alignItems: 'center',
};

function useIsClient() {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );
}

interface LinksProps {
  isLoggedIn: boolean;
  isMobile: boolean;
}

const Links = ({ isLoggedIn, isMobile }: LinksProps) => {
  const menu = useRef<Menu>(null);
  const domLoaded = useIsClient();
  const { data: hasAccessToMaturityModel } = useCanViewMaturityModelPage(isLoggedIn);

  const itemTemplate = (item: MenuItem) => (
    <Link prefetch={false} href={item.url as string} className={styles.itemLink}>
      {item.label}
    </Link>
  );

  const items: MenuItem[] = [
    {
      label: 'Manage',
      items: [
        {
          label: 'TIME ALLOCATION',
          url: '/manage/time-allocation',
          template: itemTemplate,
        },
        ...(hasAccessToMaturityModel
          ? [
              {
                label: 'PRODUCT MATURITY',
                url: '/admin/maturity-model',
                template: itemTemplate,
              },
            ]
          : []),
        {
          label: 'INSTALLED BASE',
          url: '/admin/country/maps',
          template: itemTemplate,
        },
      ],
    },
  ];

  return (
    isLoggedIn &&
    domLoaded &&
    (isMobile ? (
      <>
        <Button
          startIcon={<MenuOutlined />}
          sx={{ mr: 1, color: '#fff' }}
          onClick={(event) => menu.current?.toggle(event)}
          aria-haspopup
          variant="text"
        />
        <Menu model={items} popup ref={menu} />
      </>
    ) : (
      <>
        <Link prefetch={false} href="/manage/time-allocation" style={{ marginRight: '3rem' }}>
          <Typography sx={linkSx}>TIME ALLOCATION</Typography>
        </Link>
        {hasAccessToMaturityModel && (
          <Link prefetch={false} href="/admin/maturity-model" style={{ marginRight: '3rem' }}>
            <Typography sx={linkSx}>PRODUCT MATURITY</Typography>
          </Link>
        )}
        <Link prefetch={false} href="/admin/country/maps">
          <Typography sx={linkSx}>INSTALLED BASE</Typography>
        </Link>
      </>
    ))
  );
};

export default Links;
